module.exports = __webpack_public_path__ + "img/icon22_17.21d17763.png";